import React from "react";
import ContentSummariesPage from "./Pages/ContentSummariesPage";

const ContentSummariesRouter = () => {
    return <ContentSummariesPage />;
};

export default ContentSummariesRouter;
